import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/more/settings")({
  component: () => <Outlet />,
});
